import { ImpulseFormUnit } from "~/tools/impulse-form";
import { isStringDirty } from "~/tools/is-string-dirty";
import { trim } from "~/tools/trim";
import { Tuple } from "~/tools/tuple";
import { theme } from "~/tools/twin-migration";

const CRITICAL = theme("colors.graph-red.20");
const WARNING = theme("colors.graph-orange.20");
const HEALTHY = theme("colors.graph-green.20");

const PRESET_COLORS = Tuple(CRITICAL, WARNING, theme("colors.graph-blue.20"), HEALTHY, theme("colors.graph-purple.20"));

type WidgetColor = ImpulseFormUnit<string>;

function init(initial = CRITICAL): WidgetColor {
	return ImpulseFormUnit(initial, {
		isInputDirty: isStringDirty,
		transform: trim,
	});
}

const WidgetColor = {
	default: CRITICAL,
	critical: CRITICAL,
	warning: WARNING,
	healthy: HEALTHY,
	preset: PRESET_COLORS,
	init,
} as const;

export { WidgetColor };
